export interface MangaChapter {
  slug: string;
  title: string;
  pages: number;
  isLatest?: boolean;
}

export interface MangaItem {
  slug: string;
  title: string;
  originalTitle: string;
  author: string;
  status: "连载中" | "已完结";
  categorySlugs: string[];
  tags: string[];
  rating: number;
  views: string;
  likes: number;
  description: string;
  longDescription: string;
  latestChapter: string;
  updateDate: string;
  cover: string;
  featured: boolean;
  chapters: MangaChapter[];
}

export const mangaList: MangaItem[] = [
  {
    slug: "qingmei",
    title: "青梅竹马不断向我甜蜜求婚",
    originalTitle: "青梅竹马不断向我甜蜜求婚",
    author: "糖心丸",
    status: "已完结",
    categorySlugs: ["love", "sweet", "complete"],
    tags: ["青梅竹马", "双向暗恋", "高甜", "大结局"],
    rating: 9.8,
    views: "2.6亿",
    likes: 386000,
    description:
      "从小一起长大的邻居哥哥，长大后却不断向我甜蜜求婚！从儿时的约定到毕业后的重逢，这份藏在心底多年的喜欢终于藏不住了。",
    longDescription:
      "林小满和顾言舟是从小一起长大的青梅竹马。小时候，顾言舟总是牵着她的手说“长大后我要娶你”。多年后他从国外留学归来，成了她公司隔壁的年轻总裁。重逢那天，他再次把戒指递到她面前：“这次，我不会再让你跑掉了。”从校园到职场，从青涩到成熟，这段跨越十年的双向暗恋，终于在一次次甜蜜求婚中开花结果。全篇完结，大结局一次性畅读。",
    latestChapter: "大结局 一生一世",
    updateDate: "2026-08-12",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20young%20woman%20and%20man%20as%20childhood%20sweethearts%20in%20high%20school%20uniform%2C%20the%20boy%20holds%20out%20a%20small%20engagement%20ring%20box%20with%20a%20shy%20smile%2C%20falling%20cherry%20blossom%20petals%2C%20warm%20coral%20and%20peach%20color%20palette%2C%20soft%20dreamy%20background%2C%20clean%20composition%2C%20high%20quality%20shoujo%20manga%20digital%20art&width=600&height=840&seq=cover-qingmei&orientation=portrait",
    featured: true,
    chapters: [
      { slug: "ch-1", title: "第1话 儿时的约定", pages: 24 },
      { slug: "ch-2", title: "第2话 转学归来的他", pages: 26 },
      { slug: "ch-3", title: "第3话 同桌的你", pages: 22 },
      { slug: "ch-4", title: "第4话 情书风波", pages: 25 },
      { slug: "ch-5", title: "第5话 夏日祭的烟火", pages: 28 },
      { slug: "ch-6", title: "第6话 偷偷的心动", pages: 23 },
      { slug: "ch-7", title: "第7话 误会与和解", pages: 27 },
      { slug: "ch-8", title: "第8话 告白前夕", pages: 24 },
      { slug: "ch-9", title: "第9话 甜蜜告白", pages: 26 },
      { slug: "ch-10", title: "第10话 同居日常", pages: 25 },
      { slug: "ch-11", title: "第11话 求婚进行时", pages: 27 },
      { slug: "ch-end", title: "大结局 一生一世", pages: 30, isLatest: true },
    ],
  },
  {
    slug: "aiqingbaifa",
    title: "爱情的一百种方式",
    originalTitle: "爱情的一百种方式",
    author: "桃子乌龙",
    status: "连载中",
    categorySlugs: ["love", "city"],
    tags: ["都市爱情", "久别重逢", "治愈"],
    rating: 9.3,
    views: "1.1亿",
    likes: 152000,
    description:
      "失联七年的初恋，竟成了我新公司的甲方。他说：这次换我来追你，用我学会的所有方式。",
    longDescription:
      "27岁的周可在一家广告公司做创意总监，却在竞标会上遇见了七年前不告而别的初恋季闻舟。他如今是集团最年轻的合伙人，却还是会在下班后等在她的楼下。这一次，季闻舟决定把所有错过的时间都补回来——用一百种笨拙又真诚的方式，重新追回她。",
    latestChapter: "第45话 楼下的灯",
    updateDate: "2026-08-11",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20stylish%20young%20couple%20standing%20on%20a%20city%20rooftop%20at%20golden%20hour%2C%20warm%20sunset%20glow%2C%20city%20skyline%20background%2C%20the%20man%20looks%20at%20the%20woman%20with%20tender%20eyes%2C%20romantic%20adult%20love%20story%20mood%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20clean%20shoujo%20manga%20art&width=600&height=840&seq=cover-aiqingbaifa&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 七年前的告别", pages: 24 },
      { slug: "ch-2", title: "第2话 会议室重逢", pages: 26 },
      { slug: "ch-3", title: "第3话 甲方是前任", pages: 22 },
      { slug: "ch-4", title: "第4话 楼下的灯", pages: 25 },
      { slug: "ch-5", title: "第5话 深夜食堂", pages: 23 },
    ],
  },
  {
    slug: "xiaocaoshiwotongzuo",
    title: "校草是我同桌",
    originalTitle: "校草是我同桌",
    author: "阿茶不苦",
    status: "连载中",
    categorySlugs: ["campus"],
    tags: ["校园", "暗恋", "同桌"],
    rating: 9.1,
    views: "9200万",
    likes: 128000,
    description:
      "转学第一天，我和全年级最受欢迎的校草成了同桌。为了不被发现我喜欢他，我决定……先跟他做兄弟。",
    longDescription:
      "高二转学生陈浅浅因为成绩优秀被安排和年级第一的校草沈喻同桌。沈喻高冷寡言，却总在不知不觉中照顾她：帮她挡住走廊里的人群，把自己带的小蛋糕分她一半。陈浅浅一边心动一边努力维持“好兄弟”人设，直到某天校草在讲台上说：“我喜欢的人，是我的同桌。”",
    latestChapter: "第38话 讲台告白",
    updateDate: "2026-08-10",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20handsome%20high%20school%20boy%20sitting%20at%20a%20classroom%20desk%20beside%20a%20blushing%20girl%2C%20sunlight%20through%20window%2C%20campus%20romance%20mood%2C%20warm%20cream%20and%20soft%20peach%20tones%2C%20clean%20shoujo%20manga%20art%2C%20fresh%20youthful%20atmosphere%2C%20portrait%20format%20digital%20illustration&width=600&height=840&seq=cover-xiaocaoshi&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 新同桌", pages: 22 },
      { slug: "ch-2", title: "第2话 半个小蛋糕", pages: 24 },
      { slug: "ch-3", title: "第3话 篮球场风波", pages: 26 },
      { slug: "ch-4", title: "第4话 天台偶遇", pages: 23 },
    ],
  },
  {
    slug: "xindongyujing",
    title: "心动预警",
    originalTitle: "心动预警",
    author: "奶盖不甜",
    status: "连载中",
    categorySlugs: ["sweet", "campus"],
    tags: ["甜宠", "反差萌", "校园"],
    rating: 9.4,
    views: "1.3亿",
    likes: 176000,
    description:
      "全校最凶的纪律委员，其实是个一害羞就结巴的小可爱？只有我知道他有多甜。",
    longDescription:
      "纪深是全校闻名的“冷面纪律委员”，凶名在外，没人敢招惹。直到转学生苏糖糖发现，这位纪同学一被叫小名就脸红，一害羞就结巴，还会偷偷给她塞小纸条。一个想立威，一个想装乖，这场“心动预警”一触即发。",
    latestChapter: "第52话 公开的秘密",
    updateDate: "2026-08-12",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20cute%20girl%20with%20sparkling%20eyes%20and%20a%20shy%20serious%20school%20boy%20holding%20a%20small%20note%2C%20pink%20sparkle%20effects%2C%20sweet%20romantic%20comedy%20mood%2C%20warm%20pink%20and%20coral%20palette%2C%20soft%20background%2C%20clean%20shoujo%20manga%20art%2C%20portrait%20format&width=600&height=840&seq=cover-xindongyujing&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 转学第一天", pages: 24 },
      { slug: "ch-2", title: "第2话 凶凶的同桌", pages: 25 },
      { slug: "ch-3", title: "第3话 小纸条", pages: 23 },
      { slug: "ch-4", title: "第4话 脸红现场", pages: 26 },
    ],
  },
  {
    slug: "chuanyuehoukaimeishi",
    title: "穿越后靠美食当团宠",
    originalTitle: "穿越后靠美食当团宠",
    author: "香菜怪",
    status: "连载中",
    categorySlugs: ["comedy", "city"],
    tags: ["穿越", "美食", "团宠", "搞笑"],
    rating: 9.0,
    views: "7800万",
    likes: 98000,
    description:
      "美食博主穿进漫画世界，靠一手好菜征服全城，连高冷男主都被我的蛋炒饭收买了。",
    longDescription:
      "美食博主苏小满一觉醒来发现自己穿进了漫画《都市食神》的世界，成了书里活不过三集的炮灰。她决定自救——先摆摊卖奶茶，再开深夜食堂，用一道道中华美食征服挑剔的食客们，包括那位号称“舌头很金贵”的高冷男主。",
    latestChapter: "第41话 深夜食堂开张",
    updateDate: "2026-08-09",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20cheerful%20young%20woman%20in%20an%20apron%20holding%20a%20hot%20pan%20of%20steaming%20egg%20fried%20rice%2C%20colorful%20delicious%20chinese%20food%20around%20her%2C%20fun%20comedy%20mood%2C%20warm%20amber%20and%20coral%20palette%2C%20clean%20manga%20art%2C%20portrait%20format%20digital%20illustration&width=600&height=840&seq=cover-chuanyue&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 穿书了", pages: 22 },
      { slug: "ch-2", title: "第2话 街头奶茶摊", pages: 24 },
      { slug: "ch-3", title: "第3话 高冷的食客", pages: 25 },
    ],
  },
  {
    slug: "zongcaidezhangxinchong",
    title: "总裁的掌心宠",
    originalTitle: "总裁的掌心宠",
    author: "江月白",
    status: "连载中",
    categorySlugs: ["city", "sweet"],
    tags: ["总裁", "先婚后爱", "高甜"],
    rating: 9.2,
    views: "1.5亿",
    likes: 203000,
    description:
      "一纸契约，她成了冷面总裁的挂名太太。说好互不打扰，他却把她宠成了全城最让人羡慕的掌心宠。",
    longDescription:
      "为了救回病重的父亲，林知夏与顾氏集团总裁顾北城签下一年契约婚姻。她以为这只是交易，他却在她被欺负时挡在前面，在她加班时送来温热的汤，在她生日时清空整家花店。当契约期满，他红着眼眶说：“合同可以作废，但你要留下。”",
    latestChapter: "第60话 不想放你走",
    updateDate: "2026-08-12",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20an%20elegant%20powerful%20ceo%20man%20in%20a%20suit%20gently%20holding%20a%20graceful%20woman%20in%20a%20dress%2C%20luxury%20city%20penthouse%20background%2C%20warm%20evening%20light%2C%20romantic%20mature%20love%20mood%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20shoujo%20manga%20art%2C%20portrait%20format&width=600&height=840&seq=cover-zongcai&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 契约婚姻", pages: 24 },
      { slug: "ch-2", title: "第2话 挂名太太", pages: 26 },
      { slug: "ch-3", title: "第3话 深夜的汤", pages: 25 },
      { slug: "ch-4", title: "第4话 生日惊喜", pages: 27 },
    ],
  },
  {
    slug: "xuebadelianairiji",
    title: "学霸的恋爱日记",
    originalTitle: "学霸的恋爱日记",
    author: "木子李",
    status: "连载中",
    categorySlugs: ["campus", "love"],
    tags: ["学霸", "年下", "双学霸"],
    rating: 8.9,
    views: "6400万",
    likes: 86000,
    description:
      "年级第一的乖乖女学霸，被隔壁班的小学弟用一道奥数题打开了心扉。恋爱嘛，也要讲究解题思路。",
    longDescription:
      "学霸姜宁的人生计划里从来没有恋爱这一项，直到遇见了那个总在图书馆角落研究奥数的学弟陆一舟。他把她当成“研究对象”，她却在他递来的解题笔记里发现了一张电影票。当理性碰撞上心动，学霸也会手忙脚乱。",
    latestChapter: "第28话 图书馆之约",
    updateDate: "2026-08-08",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20focused%20studious%20girl%20with%20glasses%20holding%20a%20notebook%20and%20a%20smiling%20younger%20school%20boy%20leaning%20beside%20her%20in%20a%20library%2C%20warm%20bookshelf%20background%2C%20fresh%20academic%20romance%20mood%2C%20warm%20cream%20and%20soft%20peach%20tones%2C%20clean%20shoujo%20manga%20art%2C%20portrait%20format&width=600&height=840&seq=cover-xueba&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 图书馆偶遇", pages: 22 },
      { slug: "ch-2", title: "第2话 解题笔记", pages: 24 },
      { slug: "ch-3", title: "第3话 电影票", pages: 23 },
    ],
  },
  {
    slug: "hezhipianrenlaogong",
    title: "和纸片人老公双向奔赴",
    originalTitle: "和纸片人老公双向奔赴",
    author: "鱼丸粗面",
    status: "连载中",
    categorySlugs: ["comedy"],
    tags: ["穿漫", "沙雕", "双向奔赴"],
    rating: 9.1,
    views: "8900万",
    likes: 112000,
    description:
      "我追了三年的漫画男主，居然破次元壁来找我了！他还说要跟我“双向奔赴”，可他不会坐地铁啊！",
    longDescription:
      "重度漫画迷曲奇爱追一部冷门恋爱漫《春日将至》，最喜欢里面的男主陆时雨。某天，这个高冷纸片人居然从漫画里穿了出来，站在她家门口。他不会用手机、不会坐地铁、不懂奶茶是什么，却会用最笨拙的方式对她说：“作者说，我们本来就是双向奔赴。”",
    latestChapter: "第33话 次元壁破裂",
    updateDate: "2026-08-07",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20surprised%20happy%20girl%20standing%20next%20to%20a%20handsome%20anime%20man%20jumping%20out%20of%20an%20open%20comic%20book%20with%20sparkles%2C%20playful%20funny%20mood%2C%20warm%20coral%20and%20yellow%20palette%2C%20clean%20comedy%20manga%20art%2C%20portrait%20format%20digital%20illustration&width=600&height=840&seq=cover-zhijianren&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 他穿出来了", pages: 24 },
      { slug: "ch-2", title: "第2话 不会坐地铁", pages: 23 },
      { slug: "ch-3", title: "第3话 奶茶教学", pages: 25 },
    ],
  },
  {
    slug: "xiarixiandinglianai",
    title: "夏日限定恋爱",
    originalTitle: "夏日限定恋爱",
    author: "西瓜甜不甜",
    status: "已完结",
    categorySlugs: ["campus", "complete"],
    tags: ["夏日", "花火大会", "青春", "完结"],
    rating: 9.5,
    views: "1.2亿",
    likes: 168000,
    description:
      "一个夏天的补习班，一场花火大会的约定。青春里的喜欢，总是猝不及防。已完结，可一次性畅读结局。",
    longDescription:
      "高二的夏天，林晚被妈妈塞进补习班，遇见了隔壁重点班的学神程野。他们一起做卷子、吃冰棍、在夏夜的天台上听蝉鸣。他说：“这场恋爱，限定一个夏天。”可当夏天结束，喜欢却悄悄变成了永远。全篇完结，含大结局番外。",
    latestChapter: "大结局 来年夏天",
    updateDate: "2026-07-30",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20teenage%20couple%20in%20yukata%20watching%20fireworks%20at%20a%20summer%20festival%2C%20glowing%20colorful%20fireworks%20in%20night%20sky%2C%20warm%20golden%20and%20coral%20tones%2C%20nostalgic%20youth%20romance%20mood%2C%20clean%20shoujo%20manga%20art%2C%20portrait%20format&width=600&height=840&seq=cover-xiari&orientation=portrait",
    featured: true,
    chapters: [
      { slug: "ch-1", title: "第1话 盛夏补习班", pages: 24 },
      { slug: "ch-2", title: "第2话 天台蝉鸣", pages: 25 },
      { slug: "ch-3", title: "第3话 花火大会", pages: 28 },
      { slug: "ch-4", title: "大结局 来年夏天", pages: 30, isLatest: true },
    ],
  },
  {
    slug: "naichadianxiaojiejie",
    title: "奶茶店的小姐姐",
    originalTitle: "奶茶店的小姐姐",
    author: "珍珠奶茶三分甜",
    status: "连载中",
    categorySlugs: ["city", "comedy"],
    tags: ["治愈", "日常", "暖萌"],
    rating: 8.8,
    views: "5600万",
    likes: 74000,
    description:
      "常客先生每天准时来买同一种奶茶，今天却递来一张写着电话号码的小票。",
    longDescription:
      "在小区门口开奶茶店的温温柔，每天都会遇到一位准时报到的常客。他总点“黑糖珍珠奶茶，三分糖”，却从不说话。直到某天，小票背面多了一行字：“我能预约明天的第一杯奶茶吗？也顺便预约你。”",
    latestChapter: "第25话 小票上的号码",
    updateDate: "2026-08-06",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20sweet%20smiling%20barista%20girl%20behind%20a%20cozy%20milk%20tea%20shop%20counter%20holding%20a%20cup%20of%20brown%20sugar%20pearl%20milk%20tea%2C%20warm%20cafe%20lighting%2C%20pastel%20interior%2C%20warm%20cream%20and%20caramel%20palette%2C%20clean%20shoujo%20manga%20art%2C%20portrait%20format%20digital%20illustration&width=600&height=840&seq=cover-naicha&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 三分糖", pages: 22 },
      { slug: "ch-2", title: "第2话 常客先生", pages: 24 },
      { slug: "ch-3", title: "第3话 小票背面", pages: 23 },
    ],
  },
  {
    slug: "wenroutongzhuo",
    title: "温柔同桌是隐藏大佬",
    originalTitle: "温柔同桌是隐藏大佬",
    author: "甜甜圈",
    status: "连载中",
    categorySlugs: ["campus"],
    tags: ["反差", "马甲", "校园"],
    rating: 9.0,
    views: "7200万",
    likes: 96000,
    description:
      "看起来温柔老实的同桌，背地里竟然是游戏圈人气第一的神秘主播？",
    longDescription:
      "姜糖的温柔同桌陆止，总是安安静静地帮她讲题、带早餐。直到有一天，她在电竞直播里看到了那张无比熟悉的脸——那个操作炸裂、弹幕刷屏的神秘主播“止水”，居然就是她同桌！而且他直播间的简介写着：给某人带了一学期的早餐，什么时候能换她主动一次。",
    latestChapter: "第31话 掉马现场",
    updateDate: "2026-08-05",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20gentle%20looking%20school%20boy%20with%20soft%20smile%20sitting%20beside%20a%20surprised%20girl%20at%20a%20classroom%20desk%2C%20a%20subtle%20headset%20and%20game%20controller%20nearby%2C%20warm%20sunlight%2C%20cute%20secret%20identity%20mood%2C%20warm%20cream%20and%20peach%20palette%2C%20clean%20shoujo%20manga%20art%2C%20portrait%20format&width=600&height=840&seq=cover-wenrou&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 温柔的麻烦精", pages: 22 },
      { slug: "ch-2", title: "第2话 直播间", pages: 24 },
      { slug: "ch-3", title: "第3话 掉马", pages: 25 },
    ],
  },
  {
    slug: "badaochushandequhun",
    title: "霸道厨神的求婚计划",
    originalTitle: "霸道厨神的求婚计划",
    author: "胡椒面",
    status: "已完结",
    categorySlugs: ["sweet", "complete"],
    tags: ["厨神", "美食", "求婚", "完结"],
    rating: 9.2,
    views: "8300万",
    likes: 109000,
    description:
      "米其林三星主厨有个秘密计划：用一百道菜，换她一句“我愿意”。已完结，大结局甜到掉牙。",
    longDescription:
      "冷面厨神沈知味有个只有自己知道的计划——从认识那天起，每天为她做一道不同的菜，菜名连起来是求婚的话。一百天、一百道菜，当他终于端出最后一道“心有所属”时，餐盘下压着戒指。全篇完结，一次看完全部剧情。",
    latestChapter: "大结局 心有所属",
    updateDate: "2026-07-28",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20confident%20handsome%20chef%20man%20in%20a%20white%20apron%20holding%20a%20ring%20box%20next%20to%20an%20elegant%20table%20of%20gourmet%20chinese%20dishes%2C%20warm%20kitchen%20lighting%2C%20romantic%20food%20love%20mood%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20shoujo%20manga%20art%2C%20portrait%20format&width=600&height=840&seq=cover-chushen&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 第一百道菜", pages: 24 },
      { slug: "ch-2", title: "第2话 麻辣的心", pages: 23 },
      { slug: "ch-3", title: "大结局 心有所属", pages: 28, isLatest: true },
    ],
  },
  {
    slug: "xindongdexinhao",
    title: "心动的信号",
    originalTitle: "心动的信号",
    author: "向南",
    status: "连载中",
    categorySlugs: ["love", "city"],
    tags: ["暗恋", "办公室", "治愈"],
    rating: 9.0,
    views: "6800万",
    likes: 88000,
    description:
      "暗恋两年的同事终于要离职了，我在告别会上说错了一句话，然后整个人生都开始往奇怪的方向狂奔。",
    longDescription:
      "人事部的小透明周知暗恋产品部总监江行两年，一直只敢偷偷看他的侧脸。离职告别会上，她借着酒劲说：“江总，你做的每一版方案我都能背下来。”全办公室安静了，江行却笑了：“那考考你，第三版第二节写的什么？”",
    latestChapter: "第22话 告别会上的告白",
    updateDate: "2026-08-04",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20shy%20office%20worker%20woman%20and%20a%20handsome%20colleague%20man%20in%20a%20modern%20office%2C%20warm%20city%20view%20behind%20glass%20window%2C%20secret%20crush%20romance%20mood%2C%20warm%20coral%20and%20amber%20palette%2C%20clean%20shoujo%20manga%20art%2C%20portrait%20format&width=600&height=840&seq=cover-xindong&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 偷偷喜欢", pages: 22 },
      { slug: "ch-2", title: "第2话 告别会", pages: 24 },
      { slug: "ch-3", title: "第3话 考考你", pages: 23 },
    ],
  },
  {
    slug: "tangfenchaobiao",
    title: "糖分超标",
    originalTitle: "糖分超标",
    author: "罐装小熊",
    status: "连载中",
    categorySlugs: ["sweet"],
    tags: ["高甜", "同居", "日常"],
    rating: 9.3,
    views: "1.0亿",
    likes: 141000,
    description:
      "和暗恋对象合租是什么体验？每天都是糖分超标的日常，我快招架不住了！",
    longDescription:
      "为了省房租，姜糖和大学暗恋的学长程一然成了合租室友。程一然什么都好，就是太爱照顾人：早上有人做早餐，下雨有人送伞，加班有人接。姜糖每天一边心动一边崩溃：“你再这样，我真的会忍不住告白的！”",
    latestChapter: "第47话 忍不住了",
    updateDate: "2026-08-11",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20cute%20couple%20sitting%20at%20a%20breakfast%20table%20with%20pancakes%20and%20jam%20in%20a%20cozy%20apartment%2C%20warm%20morning%20sunlight%2C%20sweet%20cohabitation%20romance%20mood%2C%20warm%20pink%20and%20coral%20palette%2C%20clean%20shoujo%20manga%20art%2C%20portrait%20format&width=600&height=840&seq=cover-tangfen&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 合租开始", pages: 24 },
      { slug: "ch-2", title: "第2话 爱心早餐", pages: 25 },
      { slug: "ch-3", title: "第3话 下雨的伞", pages: 23 },
    ],
  },
  {
    slug: "dushizhiyue",
    title: "都市之约",
    originalTitle: "都市之约",
    author: "拾光",
    status: "连载中",
    categorySlugs: ["city"],
    tags: ["都市", "双向奔赴", "成长"],
    rating: 8.7,
    views: "4300万",
    likes: 58000,
    description:
      "两个在都市里独自打拼的年轻人，因为一次地铁早高峰的偶遇，开始了一段互相治愈的约定。",
    longDescription:
      "早高峰的地铁里，小程和沈念几乎每天都能碰上。他们从点头之交，到互借充电宝，再到交换了微信。这座城市的节奏很快，但他们的故事可以慢慢来。每周五的“都市之约”，是他们在忙碌生活里最温柔的锚点。",
    latestChapter: "第19话 周五的约定",
    updateDate: "2026-08-03",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20young%20couple%20standing%20close%20on%20a%20subway%20platform%20at%20night%20with%20city%20lights%20bokeh%20background%2C%20warm%20urban%20romance%20mood%2C%20gentle%20smiles%2C%20warm%20coral%20and%20blue%20night%20tones%2C%20clean%20shoujo%20manga%20art%2C%20portrait%20format&width=600&height=840&seq=cover-dushi&orientation=portrait",
    featured: false,
    chapters: [
      { slug: "ch-1", title: "第1话 早高峰", pages: 22 },
      { slug: "ch-2", title: "第2话 充电宝", pages: 24 },
      { slug: "ch-3", title: "第3话 周五之约", pages: 23 },
    ],
  },
  {
    slug: "chuilianxingzai",
    title: "垂涎已久的你",
    originalTitle: "垂涎已久的你",
    author: "一颗糖",
    status: "已完结",
    categorySlugs: ["sweet", "complete"],
    tags: ["暗恋成真", "高甜", "完结"],
    rating: 9.4,
    views: "9700万",
    likes: 132000,
    description:
      "暗恋十年，他终于发现我的存在。可一开口就是：“可以跟我结婚吗？”已完结，结局超甜。",
    longDescription:
      "沈酥暗恋邻居哥哥路之遥十年，从小学到大学毕业。她以为这只是自己一个人的独角戏，直到路之遥拿着户口本出现在她家门口：“民政局下午还开门，我预约了两点半的号。你愿意吗？”全篇完结，含求婚番外。",
    latestChapter: "大结局 十年之约",
    updateDate: "2026-07-25",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20style%20cover%20illustration%20of%20a%20sweet%20shy%20girl%20peeking%20at%20a%20handsome%20young%20man%20holding%20a%20hukou%20booklet%20with%20a%20gentle%20smile%2C%20warm%20doorway%20golden%20light%2C%20sweet%20long%20time%20crush%20mood%2C%20warm%20coral%20and%20peach%20palette%2C%20clean%20shoujo%20manga%20art%2C%20portrait%20format&width=600&height=840&seq=cover-chuilian&orientation=portrait",
    featured: true,
    chapters: [
      { slug: "ch-1", title: "第1话 邻居哥哥", pages: 24 },
      { slug: "ch-2", title: "第2话 十年暗恋", pages: 26 },
      { slug: "ch-3", title: "大结局 十年之约", pages: 30, isLatest: true },
    ],
  },
];

export const getMangaBySlug = (slug: string): MangaItem | undefined =>
  mangaList.find((m) => m.slug === slug);

export const getMangaByCategory = (slug: string): MangaItem[] =>
  mangaList.filter((m) => m.categorySlugs.includes(slug));